(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaDosageDialogController', RcopiaDosageDialogController);

    RcopiaDosageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RcopiaDosage', 'RcopiaInstruction'];

    function RcopiaDosageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RcopiaDosage, RcopiaInstruction) {
        var vm = this;

        vm.rcopiaDosage = entity;
        vm.clear = clear;
        vm.save = save;
        vm.rcopiainstructions = RcopiaInstruction.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaDosage.id !== null) {
                RcopiaDosage.update(vm.rcopiaDosage, onSaveSuccess, onSaveError);
            } else {
                RcopiaDosage.save(vm.rcopiaDosage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaDosageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
